<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    redirectPath: {
      type: Object,
      required: false,
      default: null,
    },
  },
  watch: {
    chartData() {
      this.$data._chart.destroy();
      this.renderChart(this.chartData, this.buildOptions());
    },
  },
  mounted() {
    this.addPlugin({
      afterUpdate(chart) {
        const minLen = 10;
        const numDatasets = chart.config.data.datasets.length;
        const numBars = (chart.config.data.datasets[0]?.data || []).length;

        for (let barIndex = 0; barIndex < numBars; barIndex++) {
          const segments = [];

          for (let dsIndex = 0; dsIndex < numDatasets; dsIndex++) {
            const meta = chart.getDatasetMeta(dsIndex);
            if (meta.hidden) continue;
            const bar = meta.data[barIndex];
            if (!bar?._model) continue;
            const rawHeight = bar._model.base - bar._model.y;
            const value = chart.config.data.datasets[dsIndex]?.data?.[barIndex];
            if (rawHeight > 0 && value > 0) {
              segments.push({
                model: bar._model,
                value,
                height: Math.max(rawHeight, minLen),
                origBase: bar._model.base,
              });
            }
          }

          if (!segments.length) continue;

          // Bottom of the stack = largest base pixel value (canvas y goes down)
          const baseline = Math.max(...segments.map((s) => s.origBase));

          // Ascending by value → smallest at bottom, largest at top
          segments.sort((a, b) => a.value - b.value);

          let currentBase = baseline;
          for (const seg of segments) {
            seg.model.base = currentBase;
            seg.model.y = currentBase - seg.height;
            currentBase = seg.model.y;
          }
        }
      },
    });
    this.renderChart(this.chartData, this.buildOptions());
  },
  methods: {
    buildOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
        },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [{ stacked: true, ticks: { beginAtZero: true } }],
        },
        tooltips: {
          mode: "point",
          intersect: true,
        },
        onHover: (event, items) => {
          event.target.style.cursor = items.length ? "pointer" : "default";
        },
        onClick: this.handleClick,
      };
    },
    handleClick(event, items) {
      if (!this.redirectPath || !items.length) return;
      const chart = this.$data._chart;
      const element = chart.getElementAtEvent(event)[0] || items[0];
      const clickedLabel = this.chartData.labels[element._index];
      const clickedSource =
        this.chartData.datasets[element._datasetIndex]?.label;
      this.$router.push({
        ...this.redirectPath,
        query: {
          select_option: clickedSource || null,
          month: clickedLabel || null,
        },
      });
    },
  },
};
</script>
